import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
  return (
    <Box component="footer" sx={{ mt: '20px', py: 2, textAlign: 'center', backgroundColor: '#f0f0f0' }}>
      <Typography variant="body2" color="textSecondary">
        &copy; {new Date().getFullYear()} Archery Australia. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
